import {MovilDTO} from "../movil.dto";
import {BaseResponseDTO} from "./base.response.dto";


export class GetDetalleMovilResponseDTO extends BaseResponseDTO {

    success: boolean;
    msg: string;
    data: MovilDTO;

  }
